<template>
  <div id="page-product-details">

    <div class="my-4">
      <h2>Create Distribution List</h2>
    </div>
    <distribution-list-form
      v-model="model"
      ref="form"
      :disallowed-report-types="usedReportTypes"
      :loading="loading"
      :hide-add-member="true"/>

    <div class="vx-row">
      <div class="vx-col sm:w-1/2">
        <div class="mt-8 flex flex-wrap items-center justify-start">
          <vs-button
              @click="$router.back()"
              class="my-4"
          >
            Cancel
          </vs-button>
        </div>
      </div>
      <div class="vx-col sm:w-1/2">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button
              @click="create"
              class="my-4"
              color="light"
          >
            Create
          </vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import NotificationMixin from "@/components/mixins/NotificationMixin";
import SaveModelMixin from '@/components/mixins/SaveModelMixin';
import DistributionListForm from '@/views/pages/companies/DistributionList/DistributionListForm';

export default {
  name: "DistributionListCreate",
  components: {
    DistributionListForm,
  },
  mixins: [NotificationMixin, SaveModelMixin],
  data() {
    return {
      model: {},
      modelEntity: this.$api.companies.distributionLists,
      entity: 'Distribution List',
      loading: false,
      usedReportTypes: [],
    };
  },
  computed: {
    id() {
      return this.$route.params.id;
    },
  },
  mounted() {
    this.getUsedReportTypes()
  },
  methods: {
    getParams() {
      const params = this.getModelCopy(true);

      this.setReferences([
        'ReportType_FK'
      ]);

      params.Company_FK = this.id;

      return params;
    },
    async create() {
      if (!this.$refs.form.validate()) {
        this.notifyError('Not all required fields have been provided');
        return false;
      }

      this.loading = true;
      const params = this.getParams();

      //  return;
      try {
        const { data } = await this.$api.companies.distributionLists.create(params);
        this.notifySuccess('Distribution List created');

        this.$router.push({ name: 'company.distribution-list.view',
          params: { id: this.id, distributionListId: data.data.CompanyReport_PK }}).catch(() =>
        {});

      } catch (e) {
        this.notifyError('Distribution List failed to be created');
      } finally {
        this.loading = false;
      }
    },
    async getUsedReportTypes() {
      try {
        const { data } = await this.$api.companies.relationship(
            'distribution-lists',
            this.id
        );

        this.usedReportTypes = data.data.map(({Type_PK}) => parseInt(Type_PK));
      } catch(e) {
        console.log(e);
      }
    }
  },
};
</script>

<style scoped>

</style>
